<template lang="pug">
  .games-list(:class="{'--separated': isSeparated}")
    SectionTitle(v-if="withTitle") {{ $t('availableGames') }}

    .games-list__body
      .games-list__card-container(
        v-for="game in list"
        :key="game.name"
      )
        .games-list__card(
          :class="{'--soon': !game.is_enabled}"
          @click="game.is_enabled && $router.push(localeLocation(game.mainPageLink))"
        )
          img(:src="game.extra_data.image_url", :alt="game.name" v-lazy-load).games-list__card-img
          .games-list__card-body
            .games-list__card-soon(v-if="!game.is_enabled")
              .games-list__card-btn
                span {{ $t('comingSoon') }}
                InlineSvg(:src="require('~/assets/img/icons/lock.svg')")
            .games-list__card-event(v-if="game.event_count")
              | {{ $t('events', { count: game.event_count }) }}
            .games-list__card-name
              | {{ game.extra_data.title }}
            Button(is-bordered is-white icon="arrow-right") {{ $t('gamesGoTo') }}
        Button.games-list__link-account-btn(is-primary v-if="user && !gameAccount(game.name)" @click="onLink(game)")
          span.games-list__link-account {{ $t('linkAccount') }}

    .games-list__body(v-if="isSeparated" class="--second-list")
      template(v-if="games[1] && games[1].length")
        .games-list__card-container(
          v-for="game in games[1].filter(g => g.event_count)"
          :key="game.name"
        )
          .games-list__card(
            @click="$router.push(localeLocation(game.mainPageLink))"
          )
            img(:src="game.extra_data.image_url", :alt="game.name" v-lazy-load).games-list__card-img
            .games-list__card-body
              .games-list__card-event(v-if="game.event_count")
                | {{ $t('events', { count: game.event_count }) }}
              .games-list__card-name
                | {{ game.extra_data.title }}
              Button(is-bordered is-white icon="arrow-right") {{ $t('gamesGoTo') }}
          Button.games-list__link-account-btn(is-primary v-if="user && !gameAccount(game.name)" @click="onLink(game)")
            span.games-list__link-account {{ $t('linkAccount') }}

</template>

<script>
import { mapActions, mapState } from 'vuex'
import { postUrl } from '~/utils/utils'

export default {
  name: 'GamesList',

  props: {
    games: {
      type: Array,
      required: true
    },

    isSeparated: {
      type: Boolean,
      default: false
    },

    withTitle: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {}
  },

  computed: {
    ...mapState('user', ['user']),

    list () {
      return (this.isSeparated ? this.games[0] : this.games).filter(g => g.event_count)
    }
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    gameAccount (gameName) {
      return this.user?.game_accounts?.find(account => account.game === gameName)
    },

    async onLink (game) {
      this.$gtag.event('game_account_link', { step: 2, game: game.name })

      postUrl('KochavaTracker://sendEventString?nameString=purchase&priceString=0.01')

      switch (game.name) {
        case 'lichess':
          try {
            const { data } = await this.$axios.get('/games/lichess/oauth/url')

            if (data.data) {
              window.location.href = data.data
            }
          } catch (e) {
            this.$errors.handle(e)
          }

          break

        case 'pubg-desktop':
        case 'cs-go':
        case 'dota2':
          this.showModal({ component: 'ModalSteamConnect', data: { game } })
          break

        case 'clash-royale':
          this.showModal({ component: 'ClashRoyaleAccount' })
          break

        case 'brawl-stars':
          this.showModal({ component: 'BrawlStarsAccount' })
          break

        case 'fortnight':
        case 'fortnite':
        case 'valorant':
        case 'apex-legends':
        case 'mobile-legends':
          this.showModal({ component: 'Dota2Account', data: { gameName: game.name } })
          break

        case 'game-pix':
          break

        default:
          this.showModal({
            component: 'PubgMobileAccount',
            data: { gameName: game.name }
          })
      }
    }
  }
}
</script>

<style lang="scss">
.games-list {
  &__body {
    margin-top: 32px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    column-gap: 24px;
    row-gap: 24px;

    @media (max-width: 1500px) {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }

    @media (max-width: $breakpointDesktop) {
      margin-top: 24px;
      column-gap: 16px;
      row-gap: 16px;
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    @media (max-width: $breakpointTablet) {
      grid-template-columns: 1fr 1fr;
      column-gap: 16px;
      row-gap: 16px;
    }

    &.--second-list {
      border-top: 1px solid #5568772b;
      margin-top: 16px;
      padding-top: 16px;

      @media (max-width: $breakpointTablet) {
        margin-top: 8px;
        padding-top: 8px;
      }
    }
  }

  &__card {
    width: 100%;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    cursor: pointer;
    min-height: 163px;

    @media (max-width: $breakpointTablet) {
      border-radius: 8px;
    }

    &-container {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 8px;
    }

    img {
      object-fit: cover;
      height: 280px;
      width: 100%;
      border-radius: 16px;

      @media (max-width: $breakpointTablet) {
        border-radius: 8px;
      }
    }

    &-soon {
      @include heading4;

      color: $primary60;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;

      @media (max-width: $breakpointMobile) {
        font-size: 12px;
        line-height: 14px;
      }

      .games-list__card-btn {
        border-radius: 4px;
        padding: 3px 20px 5px;
        box-shadow:
          0 10px 20px -6px transparentize(
            $color: #445669,
            $amount:
            0.73
          );
        position: relative;
        z-index: 3;
        background: #445669;
      }

      span {
        color: white;
      }

      svg {
        width: 20px;
        height: 20px;
        position: relative;
        top: -1px;
        margin-left: 4px;
      }
    }

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 100%;
      height: 100%;
      background:
        linear-gradient(
          to bottom,
          $blue-grey90 0,
          rgba($blue-grey90, 0) 50%,
          $blue-grey90 100%
        );
      opacity: 0.7;
      transition: 0.2s $easing;
      pointer-events: none;

      @media (max-width: $breakpointMobile) {
        opacity: 1;
      }
    }

    &-body {
      width: 100%;
      height: 100%;
      padding: 16px;
      border-radius: 16px;
      overflow: hidden;
      border: 1px solid $blue-grey60;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: absolute;
      background: transparent;
      top: 0;
      left: 0;
      transition: background 0.2s $easing;

      @media (max-width: $breakpointTablet) {
        border-radius: 8px;
      }

      @media (max-width: $breakpointMobile) {
        padding: 8px 8px 12px;
      }
    }

    &-img {
      width: 100%;
    }

    &-event {
      font-weight: 500;
      font-size: 17px;
      line-height: 14px;
      color: white;
      position: relative;
      top: -3px;

      @media (max-width: $breakpointMobile) {
        font-size: 12px;
        top: 0;
      }
    }

    &-name {
      @include heading4;

      color: $white;
      margin: auto 0 0;
      transform: translateY(0);
      transition: 0.2s $easing;

      @media (max-width: $breakpointMobile) {
        font-size: 13px;
        line-height: 8px;
      }
    }

    .button {
      position: absolute;
      border-color: $primary60;
      width: calc(100% - 32px);
      left: 50%;
      transform: translate(-50%, 140%);
      bottom: 16px;
      transition: 0.2s $easing;

      &__body {
        justify-content: center;
      }
    }

    @media (min-width: $breakpointTablet) {
      &:hover:not(.--soon) {
        .button {
          transform: translate(-50%, 0%);
          opacity: 1;
        }

        .games-list__card {
          &-name {
            transform: translateY(-52px);
          }

          .button {
            transform: translate(-50%, 0%);
          }
        }
      }
    }

    &.--soon {
      cursor: default;

      img {
        opacity: 0.2;
      }
    }
  }

  .games-list__card-soon .games-list__card-btn {
    @media (max-width: $breakpointMobile) {
      padding: 3px 6px;
      font-size: 9px;
    }
  }

  .games-list__card-soon svg {
    @media (max-width: $breakpointMobile) {
      width: 14px;
      height: 14px;
      margin-left: 2px;
    }
  }

  &__link-account {
    font-size: 12px;
    line-height: 14px;

    &-btn {
      width: 100% !important;
    }
  }
}
</style>
